export default __webpack_public_path__ + "static/media/background.fc683dbd.jpg";